import { FC, useCallback, useEffect, useState } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { useStyles } from "../styles";
import { MultipleSelectField } from "componentsNew/elements/MultipleSelectField";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import {
  fleetSelectAllStationsFilters,
  fleetSelectAllStatusFilters,
  fleetUpdateSettings,
  getAllFleetsData,
} from "actions/daAndFleetActions";
import { DISPATCHER, fleetStatusConstants, MANAGER } from "constants/constants";
import { SearchInput } from "componentsNew/elements/SearchInput";
import { useDispatch } from "react-redux";
import { CustomDrawer } from "componentsNew/drawers/CustomDrawer";
import Tune from "@material-ui/icons/Tune";
import { FleetTableSetitngsDrawerContent } from "componentsNew/drawers/drawerContent/FleetTableSetitngsDrawerContent";
import { ModalWindow } from "componentsNew/modals/ModalWindow";
import { FleetStatusChangeModalContent } from "componentsNew/modals/modalContent/FleetStatusChangeModalContent";
import useResize from "hooks/useResize";

const FleetHead: FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [search, setSearch] = useState<string>("");
  const { width } = useResize();
  const { userData } = useTypeSelectors((state) => state.auth);
  const {
    fleetData: { fleetListFilters, idListForUpdate },
  } = useTypeSelectors((state) => state.daAndFleets);

  const stations = Array.isArray(fleetListFilters?.stations)
    ? fleetListFilters?.stations?.join("_")
    : "";
  const statuses = Array.isArray(fleetListFilters?.statuses)
    ? fleetListFilters?.statuses?.join("_")
    : "";

  useEffect(() => {
    if (stations && statuses) {
      dispatch(
        getAllFleetsData(
          fleetListFilters?.pageNumber + 1,
          fleetListFilters?.rowsPerPage,
          fleetListFilters?.ordering,
          stations,
          statuses,
          search,
        ),
      );
    }
  }, [
    stations,
    statuses,
    fleetListFilters?.rowsPerPage,
    fleetListFilters?.pageNumber,
    fleetListFilters?.ordering,
    search,
    dispatch,
  ]);

  const handleChangeStations = useCallback(
    (stations: number[]) => {
      dispatch(fleetUpdateSettings({ stations: stations }));
    },
    [dispatch],
  );

  const handleSelectAllStations = useCallback(
    () => dispatch(fleetSelectAllStationsFilters()),
    [dispatch],
  );

  const handleChangeStatuses = useCallback(
    (statuses: number[]) => {
      dispatch(fleetUpdateSettings({ statuses }));
    },
    [dispatch],
  );

  const handleSelectAllStatuses = useCallback(
    () => dispatch(fleetSelectAllStatusFilters()),
    [dispatch],
  );

  const stationOptions = userData.station_spots.map((spot) => ({
    value: spot.station.id,
    label: spot.station.title,
  }));
  const statusOptions = fleetStatusConstants.map((status) => ({
    value: status.value,
    label: status.option,
  }));

  return (
    <Box className={classes.paper}>
      <Box className={classes.filters}>
        <Box className={classes.filtersLeft}>
          <Box className={classes.filterBox}>
            <MultipleSelectField
              options={stationOptions}
              selected={fleetListFilters?.stations}
              action={handleChangeStations}
              actionAll={handleSelectAllStations}
              label="Stations"
              allLabel="All Stations"
              autoSelectAll
              hideLabel={840 > width}
            />
            <MultipleSelectField
              options={statusOptions}
              selected={fleetListFilters?.statuses}
              action={handleChangeStatuses}
              actionAll={handleSelectAllStatuses}
              label="Statuses"
              allLabel="All Status"
              autoSelectAll
              hideLabel={840 > width}
            />
          </Box>
          <Box className={classes.filterBox}>
            <SearchInput value={search} onChange={setSearch} placeholder="Fleet No. / Plate No." />
            <CustomDrawer
              customWidth={width > 840 ? 440 : 256}
              buttonType={"custom"}
              drawer_name={`da-table-settings`}
              drawerTitle={`Table Settings`}
              customButtonElement={
                <Button className={classes.settingsBtn} variant={"outlined"}>
                  <Tune /> {width > 840 ? <Typography>Settings</Typography> : ""}
                </Button>
              }
              disableMobileFullWidth
            >
              <FleetTableSetitngsDrawerContent />
            </CustomDrawer>
          </Box>
        </Box>
        <Box className={classes.filtersRight}>
          {idListForUpdate?.length ? (
            <Typography>{idListForUpdate.length} selected</Typography>
          ) : (
            ""
          )}
          <ModalWindow
            modal_name={"fleet-edit-status-modal"}
            buttonType={"button"}
            buttonText={"Change Status"}
            modalTitle={"Change Fleet Status"}
            isDisabled={!idListForUpdate?.length || [DISPATCHER, MANAGER].includes(userData.role)}
          >
            <FleetStatusChangeModalContent />
          </ModalWindow>
        </Box>
      </Box>
    </Box>
  );
};

export default FleetHead;
